export const EN_TRANSLATION = {
  required: 'Required',
  optional: 'Optional',
  gender: 'Gender',
  language: 'Language',
  education: 'Education',
  ethnicity: 'Ethnicity',
  race: 'Race',
  must_have: 'Must Have',
  select_one_or_more: 'Select one or more',
  valid_date: 'Please enter a valid date.',
  valid_year: 'Please enter a valid year.',
  valid_month: 'Please enter a valid month.',
  valid_day: 'Please enter a valid day.',
  valid_name: 'Please enter a valid name.',
  valid_mrn: 'Please enter a valid MRN.',
  valid_value: 'Please enter a valid value.',
  valid_phone_number: 'Please enter a valid phone number.',
  valid_phone_number_count: 'Please enter a valid 10-digit phone number.',
  valid_area_code:
    'Please enter a valid area code starting with a number 2 - 9.',
  valid_required: 'Please fill out this field.',
  availability_event_type_error:
    'Please choose In Person, Virtual, or both to create availability.',
  valid_email: 'Please enter a valid email address.',
  valid_checkbox: 'Please check this checkbox.',
  checkbox_required: 'You must check this box to save your changes.',
  valid_min_value: 'Value must be greater than or equal to %{minValue}',
  valid_zip: 'Please enter a valid zip code.',
  valid_zip_format: 'Please enter a valid zip code (#####-####).',
  valid_suffix:
    'Please select valid suffix(es) or clear the suffix and consider adding a title.',
  valid_honorific:
    'Please select a valid title or select “No Title” and consider adding a suffix.',
  email_or_phone: 'Please select email and/or text.',
  authentication_form: 'Authentication Form',
  change_language: 'Change Language',
  notification_preferences: 'Notification Preferences',
  receive_notif_provider: 'Where should your patient receive notifications?',
  receive_notif_patient:
    'Where would you like to receive your notification(s)? You can update your email and phone number in the boxes below.',
  email: 'Email',
  phone: 'Phone',
  text_message: 'Text Message',
  text: 'Text',
  add_com_consent_provider:
    'By adding an email/phone number, you are asserting patient consent to communicate through those channels.',
  error_receiving_email_patient:
    'This email address is not able to receive email messages. Please enter a valid email address.',
  error_receiving_email_provider:
    'This email address is not able to receive email messages. Please confirm the email with the patient and enter a valid email address.',
  error_receiving_text_patient:
    'This phone number is not able to receive text messages. Please confirm the number and enter a valid number.',
  error_receiving_text_provider:
    'This phone number is not able to receive text messages. Please confirm the number with the patient and enter a valid number.',
  notif_receive_provider: 'Which notification(s) should your patient receive?',
  notif_receive_patient: 'Which notification(s) would you like to receive?',
  appoint_confirm: 'Appointment Confirmation',
  appointment_information: 'Appointment Confirmations/Cancellations',
  appoint_confirm_details:
    'Message alerting you an appointment has been booked and any special instructions from your provider.',
  appointment_information_description:
    'Messages alerting you of scheduled or cancelled appointments, and any special instructions from your provider.',
  appoint_reminder: 'Appointment Reminders',
  appoint_reminder_details:
    'Messages reminding you of any upcoming scheduled appointments.',
  appoint_cancel: 'Appointment Cancellation',
  appoint_cancel_details:
    'Message notifying you that a previously scheduled appointment has been cancelled.',
  send_assessment_link_provider: 'Send to Patient Assessment Link',
  send_assessment_link_patient: 'Assessments',
  send_assessment_link_details:
    'Messages requesting you complete an assessment from your provider.',
  communication_disclaimer:
    'Your healthcare organization or provider may still send you communications that do not come from Lucet.',
  sms_disclaimer_member_notification_preferences:
    'Receiving appointment-related text messages is optional. Message frequency varies and message and data rates may apply.',
  reply_help_or_stop: 'Reply HELP for assistance or STOP at any time to opt out.',
  privacy_policy: 'Privacy Policy',
  terms_of_use: 'Terms of Use',
  save_changes: 'Save Changes',
  enter_email_address: 'Enter email address',
  enter_mobile_number: 'Enter mobile phone number',
  sms_opt_out_patient_legacy:
    'You have opted our of text messages. To reactivate, please text START to %{contact_number} to opt back into text messaging.',
  sms_opt_out_provider_legacy:
    'This patient has opted out of text message alerts. To reactivate, the patient must text START to %{contact_number} to opt back into text messaging.',
  sms_opted_out_patient:
    'This phone number has been opted out of receiving text messages. To opt back in, please text "START" to %{contact_number} from this number, or you can update to a different phone number.',
  sms_opted_out_provider:
    'This phone number has been opted out of receiving text messages. To opt back in, the patient must text "START" to %{contact_number} from this number, or you can update to a different phone number.',
  sms_invalid:
    'This phone number is an invalid number; please update this number to a valid phone number.',
  sms_opted_out_or_invalid_patient:
    'This phone number has been opted out of receiving text messages or is an invalid number. To opt back in, please text "START" to %{contact_number} from this number, or you can update to a valid phone number.',
  sms_opted_out_or_invalid_provider:
    'This phone number has been opted out of receiving text messages or is an invalid number. To opt back in, the patient must text "START" to %{contact_number} from this number, or you can update to a valid phone number.',
  on_text: 'ON',
  off_text: 'OFF',
  turning_off_delivery_options: 'Turning Off All Delivery Options?',
  com_preference_assessment_alert:
    'Your provider uses your assessment responses to personalize your care. Before turning off both <strong>email</strong> and <strong>text</strong> delivery for assessments, please talk with your provider.',
  go_back_to_secure_link_reminder:
    'Please return to the link in the original text message or email to view your secure message. It may contain an assessment for you to complete or additional appointment details from your provider.',
  click_manage_communication_preferences:
    'Click here to manage your communication preferences.',
  showing: 'showing',
  of: 'of',
  out_of: 'out of',
  providers: 'providers',
  see_more_providers: 'See More Providers',
  mss_session_count_exclusion_text:
    'Session count may exclude visits not yet billed by your provider.',
  eap_sessions_used: 'EAP Sessions Used',
  eap_sessions_remaining: 'EAP Sessions Remaining',
  eap_sessions_used_all: 'All EAP sessions have been used.',
  // PreFilter Form translations
  prefilter_required: '(Required)',
  prefilter_optional: '(Optional)',
  prefilter_select_multiple: 'You may select more than one…',
  prefilter_gender_label: 'Gender',
  prefilter_language_label: 'Language',
  prefilter_language_subtitle: '(Other than English)',
  prefilter_education_label: 'Education',
  prefilter_ethnicity_label: 'Ethnicity',
  prefilter_race_label: 'Race',
  prefilter_must_have: 'Must have',
  prefilter_nice_to_have: 'Nice to have',
  prefilter_how_important: 'How important is this?',
  prefilter_primary_condition: 'Please select at least one primary condition.',
  back_button: 'BACK',
  next_button: 'NEXT',

  types_of_therapy_provided: 'Types of Therapy Provided',
  questions: {
    main_reason_for_calling:
      "What is the main reason (or reasons) you're calling today?",
    any_other_bh_issue_aware_of:
      "Are there any other behavioral health issues you'd like us to be aware of?",
    important_to_you_in_a_provider:
      'Which of the following are most important to you in a provider?',
  },

  eap_picker_home:
    'Schedule an Employee Assistance (EAP)/WellConnect Appointment',
  bh_picker_home: 'Schedule a Behavioral Health Appointment',
  mss_welcome_message_portal: 'Welcome to your Scheduling Platform!',

  survey_not_editable_contact_support:
    'This assessment is no longer editable and changes cannot be made. If you need to start over, please contact support.',

  // The following 3 trnaslations not have spanish equivalents.
  link_to_notification_pref_page_sent:
    'The link to the Notification Preferences page has been sent.',
  link_to_notification_pref_page_not_sent:
    'The link to the Notification Preferences page has NOT been sent.',
  plz_contact_support: 'Please contact Support for help.',
};

export const ES_TRANSLATION = {
  required: 'Obligatorio',
  optional: 'Opcional',
  gender: 'Género',
  language: 'Idioma',
  education: 'Educación',
  ethnicity: 'Etnia',
  race: 'Raza',
  must_have: 'Debe tener',
  select_one_or_more: 'Seleccione uno o más',
  valid_date: 'Por favor ingrese un fecha válido.',
  valid_year: 'Por favor ingrese un año válido.',
  valid_month: 'Por favor ingrese un mes válido.',
  valid_day: 'Por favor ingrese un día válido.',
  valid_name: 'Por favor ingrese un nombre válido.',
  valid_mrn: 'Por favor ingrese un MRN válido.',
  valid_value: 'Por favor ingrese un valor válido.',
  valid_phone_number: 'Por favor ingrese un número de teléfono válido.',
  valid_phone_number_count:
    'Ingrese un número de teléfono válido de 10 dígitos.',
  valid_area_code:
    'Ingrese un código de área válido que comience con un número del 2 al 9.',
  valid_required: 'Por favor complete este campo.',
  availability_event_type_error:
    'Elija En persona, Virtual o ambos para crear disponibilidad.',
  valid_email:
    'Por favor, introduce una dirección de correo electrónico válida.',
  valid_checkbox: 'Marque esta casilla de verificación.',
  checkbox_required: 'Debes marcar esta casilla para guardar los cambios.',
  valid_min_value: 'El valor debe ser mayor o igual que %{minValue}',
  valid_zip: 'Por favor ingrese un código postal válido.',
  valid_zip_format: 'Por favor ingrese un código postal válido (#####-####).',
  valid_suffix: 'Por favor seleccione sufijo(s) válido(s).',
  valid_honorific: 'Por favor seleccione un título válido.',
  email_or_phone:
    'Por favor seleccione correo electrónico y/o mensaje de texto.',
  authentication_form: 'Formulario de autenticación',
  change_language: 'Cambiar idioma',
  notification_preferences: 'Preferencias de notifiación',
  receive_notif_provider: '¿Dónde debería recibir notificaciones su paciente?',
  receive_notif_patient:
    '¿Dónde le gustaría recibir sus notificaciones? Puede actualizar su correo electrónico y número de teléfono en los cuadros a continuación.',
  email: 'Correo electrónico',
  phone: 'Teléfono',
  text_message: 'Mensaje de texto',
  text: 'Mensaje de texto',
  add_com_consent_provider:
    'Al agregar un correo electrónico/número de teléfono, usted afirma el consentimiento del paciente para comunicarse a través de esos canales.',
  error_receiving_email_patient:
    'Esta dirección de correo electrónico no puede recibir correos electrónicos. Ingrese una dirección de correo electrónico válida.',
  error_receiving_email_provider:
    'Esta dirección de correo electrónico no puede recibir mensajes de correo electrónico. Confirme el correo electrónico con el paciente e ingrese una dirección de correo electrónico válida.',
  error_receiving_text_patient:
    'Este número de teléfono no puede recibir mensajes de texto. Confirme el número e ingrese un número válido.',
  error_receiving_text_provider:
    'Este número de teléfono no puede recibir mensajes de texto. Confirme el número con el paciente e ingrese un número válido.',
  notif_receive_provider: '¿Qué notificaciones debería recibir su paciente?',
  notif_receive_patient: '¿Qué notificaciones le gustaría recibir?',
  appoint_confirm: 'Confirmación de cita',
  appointment_information: 'Confirmaciones/Cancelaciones de Citas',
  appoint_confirm_details:
    'Mensaje que le avisa de que se ha reservado una cita y de cualquier instrucción especial de su proveedor.',
  appointment_information_description:
    'Mensajes que le alertan sobre citas programadas o canceladas y cualquier instrucción especial de su proveedor.',
  appoint_reminder: 'Recordatorios de citas',
  appoint_reminder_details:
    'Mensajes que le recuerdan las próximas citas programadas.',
  appoint_cancel: 'Cancelación de cita',
  appoint_cancel_details:
    'Mensaje notificándole que una cita previamente programada ha sido cancelada.',
  send_assessment_link_provider: 'Enviar al enlace de evaluación del paciente',
  send_assessment_link_patient: 'Evaluaciones',
  send_assessment_link_details:
    'Mensajes solicitándole que complete una evaluación de su proveedor.',
  communication_disclaimer:
    'Su organización o proveedor de atención médica aún puede enviarle comunicaciones que no provengan de Lucet.',
  sms_disclaimer_member_notification_preferences:
    'Recibir mensajes de texto relacionados con citas es opcional. La frecuencia de los mensajes varía y pueden aplicarse tarifas de mensajería y datos.',
  reply_help_or_stop: 'Responda HELP para obtener ayuda o STOP en cualquier momento para cancelar la suscripción.',
  privacy_policy: 'Política de privacidad',
  terms_of_use: 'Términos de uso',
  save_changes: 'Guardar cambios',
  enter_email_address: 'Introduzca la dirección de correo electrónico',
  enter_mobile_number: 'Introduce el número de teléfono móvil',
  sms_opt_out_patient_legacy:
    'Has optado por nuestros mensajes de texto. Para reactivar, envíe un mensaje de texto con INICIO a %{contact_number} para volver a optar por la mensajería de texto.',
  sms_opt_out_provider_legacy:
    'This patient has opted out of text message alerts. To reactivate, the patient must text START to %{contact_number} to opt back into text messaging.',
  sms_opted_out_patient:
    'Este número de teléfono ha sido dado de baja para recibir mensajes de texto. Para volver a recibirlos, envíe un mensaje de texto con la palabra "START" al %{contact_number} desde este número o cambie a otro.',
  sms_opted_out_provider:
    'Este número de teléfono ha sido dado de baja para recibir mensajes de texto. Para volver a recibirlos, el paciente debe enviar un mensaje de texto con la palabra "START" al %{contact_number} desde este número o puede cambiar a otro.',
  sms_invalid:
    'Este número de teléfono es un número inválido; actualice este número a un número de teléfono válido.',
  sms_opted_out_or_invalid_patient:
    'Este número de teléfono ha sido dado de baja para recibir mensajes de texto o no es válido. Para volver a recibirlos, envíe un mensaje de texto con la palabra "START" al %{contact_number} desde este número o cámbielo a un número válido.',
  sms_opted_out_or_invalid_provider:
    'Este número de teléfono ha sido dado de baja para recibir mensajes de texto o no es válido. Para volver a recibirlos, el paciente debe enviar un mensaje de texto con la palabra "START" al %{contact_number} desde este número o puede cambiarlo a un número válido.',
  on_text: 'ENCENDER',
  off_text: 'APAGAR',
  turning_off_delivery_options: '¿Desactivar todas las opciones de entrega?',
  com_preference_assessment_alert:
    'Su proveedor utiliza sus respuestas a las evaluaciones para personalizar su atención. Antes de desactivar la entrega de evaluaciones por <strong>correo electrónico</strong> y  <strong>mensaje de texto</strong>, hable con su proveedor.',
  go_back_to_secure_link_reminder:
    'Por favor, vuelva al enlace del mensaje de texto o correo electrónico original para ver su mensaje seguro. Este puede contener una evaluación que deberá completar o detalles adicionales sobre su cita con el profesional.',
  click_manage_communication_preferences:
    'Haga clic aquí para administrar sus preferencias de notificación.',
  showing: 'mostrando',
  of: 'de',
  out_of: 'de',
  providers: 'proveedores',
  see_more_providers: 'Ver más proveedores',
  mss_session_count_exclusion_text:
    'El recuento de sesiones puede excluir las visitas que su proveedor aún no ha facturado.',
  eap_sessions_used: 'Sesiones EAP utilizadas',
  eap_sessions_remaining: 'Sesiones EAP restantes',
  eap_sessions_used_all: 'Se han utilizado todas las sesiones EAP.',
  // PreFilter Form translations
  prefilter_required: '(Obligatorio)',
  prefilter_optional: '(Opcional)',
  prefilter_select_multiple: 'Puedes seleccionar más de una…',
  prefilter_gender_label: 'Género',
  prefilter_language_label: 'Idioma',
  prefilter_language_subtitle: '(Aparte del inglés)',
  prefilter_education_label: 'Educación',
  prefilter_ethnicity_label: 'Etnia',
  prefilter_race_label: 'Raza',
  prefilter_must_have: 'Imprescindible',
  prefilter_nice_to_have: 'Deseable',
  prefilter_how_important: '¿Qué tan importante es esto?',
  prefilter_primary_condition:
    'Por favor seleccione al menos una condición primaria.',
  back_button: 'VOLVER',
  next_button: 'SIGUIENTE',

  types_of_therapy_provided: 'Tipos de terapia que se ofrecen',
  questions: {
    main_reason_for_calling:
      '¿Cuál es el motivo principal (o los motivos) por el que llama hoy?',
    any_other_bh_issue_aware_of:
      '¿Hay algún otro problema de salud mental que le gustaría que conozcamos?',
    important_to_you_in_a_provider:
      '¿Cuáles de los siguientes aspectos son los más importantes para usted en un proveedor?',
  },

  eap_picker_home:
    'Programe una cita de Asistencia al Empleado (EAP)/WellConnect',
  bh_picker_home: 'Programe una cita de salud conductual',
  mss_welcome_message_portal: '¡Bienvenido a su plataforma de programación!',
};

export class LanguageTranslator {
  static getTranslations = (locale) => {
    let translations;
    switch (locale) {
      case 'es':
        translations = ES_TRANSLATION;
        break;
      default:
        translations = EN_TRANSLATION;
        break;
    }
    return translations;
  };

  static translate = (locale, val) =>
    LanguageTranslator.getTranslations(locale)[val];
}
